import Marionette from 'backbone.marionette';
import { AdvertisingView, FantasyCoachView } from '../../views';

export default class FantasyCoachController extends Marionette.Object {
	fantasyCoach() {
		const rootView = this.getOption( 'rootView' );
		const view = new FantasyCoachView();
		rootView.getRegion( 'main' ).show(view);
		const advertising = new AdvertisingView({
			ad_id: 'div-gpt-ad-1610421948488-0',
			ad_path:'fantasy-coach',
			size: [[300, 250], [1,1]],
			pos: 2,
		});

		view.getRegion('advert').show(advertising)
	}
}